var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"products-founders",attrs:{"id":"from-the-founders"}},[_c('ProductsFoundersContainer',{attrs:{"product-url":_vm.parseUrl,"posts":_vm.founders.posts,"links":_vm.founders.links,"is-select":_vm.isSelect}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }